import { isArray } from "lodash";

import { swSettings } from "app/common/services/swSettings";

// --- BASE METHODS (no dependencies) ---

/** @deprecated Use `isTrial(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isTrial = (): boolean => swSettings?.components?.Home?.resources?.IsTrial ?? false;

/** @deprecated Use `isAfterTrial(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isAfterTrial = (): boolean => swSettings?.components?.Home?.resources?.IsAfterTrial ?? false;

const isDMI = (): boolean => swSettings?.user?.hasDM;

/** @deprecated Use `isNoTouch(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isNoTouch = (): boolean => swSettings?.components?.Home?.resources?.IsNoTouchUser;

/** @deprecated Use `isSI(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isSI = (): boolean => !!swSettings?.user?.hasSI;

/** @deprecated Use `isAfterTrialCC(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isAfterTrialCC = (): boolean => !!swSettings?.user?.customData?.quiz?.ShouldGoToAfterTrial;

/** @deprecated Use `isAnnual(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isAnnual = (): boolean => {
    const userPlanName = swSettings?.user?.plan;
    return userPlanName?.toLowerCase().includes("annual") ?? false;
};

// --- FIRST-LEVEL METHODS (depend on base) ---

/** @deprecated Use `isTrialOrAfterTrial(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isTrialOrAfterTrial = (): boolean => isTrial() || isAfterTrial();

/** @deprecated Use `isTrialOrAfterTrial(swSettings) || isNoTouch(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isNoTouchOrTrialOrAfterTrial = (): boolean => isTrialOrAfterTrial() || isNoTouch();

/** @deprecated Use `isDMITrial(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isDMITrial = (): boolean => isDMI() && isTrial();

/** @deprecated Use `isDMITrialOrAfterTrial(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const isDMITrialOrAfterTrial = (): boolean => isDMI() && isTrialOrAfterTrial();

/** @deprecated Use `getWorkspaceName(swSettings)` from `@app/UtilitiesAndConstants/UtilityFunctions/usersUtils` instead */
export const getWorkspaceName = (): string => {
    let workspace = swSettings?.components?.Workspaces?.resources?.WorkspaceType;
    if (isArray(workspace)) {
        workspace = workspace[0];
    }
    if (!workspace || /hook/i.test(workspace)) {
        workspace = swSettings?.components?.Home?.resources?.TrialWorkspace;
    }
    return !workspace ? "" : workspace.trim().toLowerCase();
};
